import { useMemo } from "react";
import { useCustomFields } from "../../../../../CustomFields/context"

export const useCustomFieldsConfig = () => {
    const { peopleCustomFields } = useCustomFields();

    return useMemo(() => {
        return (peopleCustomFields || []).map((field) => ({
            key: field.code,
            name: field.description
        }))
    }, [peopleCustomFields]);
}
